import React from 'react';
import { Minus, Plus } from 'lucide-react';

interface OrderSideQuantityFieldsProps {
  action: 'BUY' | 'SELL';
  quantity: string;
  onActionChange: (action: 'BUY' | 'SELL') => void;
  onQuantityChange: (quantity: string) => void;
}

const OrderSideQuantityFields: React.FC<OrderSideQuantityFieldsProps> = ({
  action,
  quantity,
  onActionChange,
  onQuantityChange,
}) => (
  <div className="flex gap-3">
    <div className="flex-1">
      <label className="block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70">Side</label>
      <div className="flex rounded-lg bg-white/[0.03] p-1 border border-white/10 h-9 items-center">
        <button
          type="button"
          onClick={() => onActionChange('BUY')}
          className={`flex-1 h-full text-[11px] font-bold rounded-md transition flex items-center justify-center ${action === 'BUY'
            ? 'bg-emerald-500/20 text-emerald-400 shadow-sm'
            : 'text-muted hover:text-foreground'
            }`}
        >
          BUY
        </button>
        <button
          type="button"
          onClick={() => onActionChange('SELL')}
          className={`flex-1 h-full text-[11px] font-bold rounded-md transition flex items-center justify-center ${action === 'SELL'
            ? 'bg-red-500/20 text-red-400 shadow-sm'
            : 'text-muted hover:text-foreground'
            }`}
        >
          SELL
        </button>
      </div>
    </div>
    <div className="flex-1">
      <label className="block text-[10px] font-bold text-muted uppercase mb-1 tracking-wider opacity-70">Qty</label>
      <div className="flex items-center h-9 bg-white/[0.03] border border-white/10 rounded-lg overflow-hidden focus-within:border-neon/50 transition">
        <button
          type="button"
          onClick={() => {
            const current = parseInt(quantity, 10) || 0;
            onQuantityChange(String(Math.max(1, current - 1)));
          }}
          className="px-2.5 h-full hover:bg-white/5 text-muted hover:text-neon transition-colors border-r border-white/5"
        >
          <Minus className="w-3 h-3" />
        </button>
        <input
          type="number"
          value={quantity}
          onChange={(event) => onQuantityChange(event.target.value)}
          onBlur={() => {
            if (quantity === '' || parseInt(quantity, 10) <= 0) onQuantityChange('1');
          }}
          min="1"
          className="w-full bg-transparent px-2 text-center text-foreground focus:outline-none h-full text-xs [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          required
        />
        <button
          type="button"
          onClick={() => {
            const current = parseInt(quantity, 10) || 0;
            onQuantityChange(String(current + 1));
          }}
          className="px-2.5 h-full hover:bg-white/5 text-muted hover:text-neon transition-colors border-l border-white/5"
        >
          <Plus className="w-3 h-3" />
        </button>
      </div>
    </div>
  </div>
);

export default OrderSideQuantityFields;
